const frozen = new WeakSet();

export function deepFreeze(object: any) {
  if (!object || typeof object !== "object") {
    return;
  }

  if (frozen.has(object)) {
    return;
  }

  frozen.add(object);

  for (const name of Reflect.ownKeys(object)) {
    deepFreeze(object[name]);
  }

  Object.freeze(object);
}
